export default {"src":"/_next/static/media/avocado.7278e9df.svg","height":27,"width":125,"blurWidth":0,"blurHeight":0};